import { create } from 'zustand';
import { Game } from '../interfaces/Games.interface';
import { persist } from 'zustand/middleware';

type GamesStore = {
  gamesFromSelectedTeams: Game[];
  setGamesFromSelectedTeams: (games: Game[]) => void;
};

export const useSelectedGamesForBCResult = create<GamesStore>()(
  persist(
    (set) => ({
      gamesFromSelectedTeams: [],
      setGamesFromSelectedTeams: (games: Game[]) =>
        set({ gamesFromSelectedTeams: games }),
    }),
    { name: 'gamesFromSelectedTeams-storage' }
  )
);
